import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button, Col, ControlLabel, FormControl, FormGroup, Modal, Tab, Tabs } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import Loadable from 'react-loading-overlay'

@observer(['globals', 'quickbooks'])
export default class ProcessPaymentsModal extends Component {

  constructor(props) {
    super(props)
    console.log('Invoice', props.invoice)
    this.state = {
      paymentMethodId: 0,
      paymentMethodName: '',
      amount: props.invoice.oneTimeTotal,
      loadableState: false
    }

    this.props.quickbooks.getQuickbooksPaymentMethods()
  }

  // STATE CHANGE HANDLERS
  onPaymentMethodChanged(e) {
    if (e.length > 0) {
      this.setState({
        paymentMethodId: e[0].id,
        paymentMethodName: e[0].name
      })
    } else {
      this.setState({
        paymentMethodId: 0,
        paymentMethodName: ''
      })
    }
  }

  onAmountChanged(e) {
    this.setState({
      amount: e.target.value
    })
  }

  // VALIDATION STATE HANDLERS
  getPaymentMethodValidationState() {
    if (this.state && this.state.paymentMethodId > 0) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getAmountValidationState() {
    if (this.state && this.state.amount != '') {
      return 'success'
    } else {
      return 'error'
    }
  }

  validateManualPaymentForm() {
    if (this.getPaymentMethodValidationState() == 'error') {
      return false
    }

    if (this.getAmountValidationState() == 'error') {
      return false
    }

    return true
  }

//  EVENT HANDLERS
  processManualPayment() {
    this.setState({
      loadableState: true
    })

    if (this.validateManualPaymentForm()) {
      //We need to remove the "." form the total dollar amount for Stripe.
      var total = parseInt( this.props.invoice.oneTimeTotal.replace('.', '') );

      const params = {
          organizationId: this.props.invoice.organizationId,
          invoiceToken: this.props.invoice.token,
          total: total,
          paymentMethodId: this.state.paymentMethodId,
          email: this.props.invoice.defaultContactEmail
      }

      this.props.quickbooks.processManualCustomerPayment(params, (data) => {
          if (data.quickbooksManualBillPayment.statusCode == 200) {
            alert('Manual payment successfully recorded in both the CRM and QB.')
            this.props.onClose()
            this.props.setLoadableState(true)
            this.props.reload()
          }
          else {
              alert(data.quickbooksManualBillPayment.data.message)
              this.setState({
                loadableState: false
              })
          }
      })
    }
    else {
      alert('Please check the form.  Required data is missing.')
      this.setState({
        loadableState: false
      })
    }
  }  

  render() {
    return (
      <Loadable active={this.state.loadableState} spinner text='Processing your request...'>
        <div className="clearfix">
          <FormGroup>
            <Col sm={2} componentClass={ControlLabel}>Type:</Col>
            <Col sm={10}>
              <FormGroup validationState={this.getPaymentMethodValidationState()}>
                <Typeahead clearButton labelKey="name" options={this.props.quickbooks.qbPaymentMethods} onChange={this.onPaymentMethodChanged.bind(this)} placeholder="Choose a payment method..." />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={2} componentClass={ControlLabel}>Amount:</Col>
            <Col sm={10} >
              <FormGroup validationState={this.getAmountValidationState()}>
                <FormControl type="text" id="amount" placeholder="Enter the payment amount..." onChange={this.onAmountChanged.bind(this)} value={ this.state.amount } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={2} componentClass={ControlLabel}></Col>
            <Col sm={10} >
              <Button onClick={this.processManualPayment.bind(this)} bsStyle="success">Submit Payment</Button>
            </Col>
          </FormGroup>
        </div>
      </Loadable>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/invoices/manualpaymentform.js